module.exports = {"440511001":"石炮台街道","440511002":"金砂街道","440511003":"金厦街道","440511004":"东方街道","440511005":"大华街道","440511006":"同益街道","440511007":"光华街道","440511008":"东墩街道","440511009":"广厦街道","440511010":"海安街道","440511011":"新福街道","440511012":"乌桥街道","440511013":"岐山街道","440511014":"永祥街道","440511015":"鮀莲街道","440511016":"鮀江街道","440511017":"月浦街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440511.json
// module id = 1979
// module chunks = 0